module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_8004.3a3caf83.png";